import { Typography } from '@mui/material';
import Grid from 'components/core/Grid';
import { listSmallRentalPolicyImage, listSmallCalendarImage, listSmallRatesPricingImage } from 'config/imageUrls';
import { ContentSection, StyledBulletList, DividerTemp } from './styles';

export const YouAreInControl = () => {
  return (
    <>
      <ContentSection>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography variant="h2" mb={2}>
              You Are in Control
            </Typography>
            <Typography>
              No matter if you are a property manager or a rental-by-owner, you are in full-control of your vacation
              rental policies, settings, availability, rates and much more.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h3" sx={{ display: 'flex', alignItems: 'center' }}>
              <img src={listSmallRentalPolicyImage} style={{ height: '48px', marginRight: '16px' }} />
              Rental Policies
            </Typography>
            <StyledBulletList>
              <li>Set house rules and restrictions.</li>
              <li>Define guest requirements.</li>
              <li>Choose cancellation/refund policies.</li>
              <li>Control damage deposit settings.</li>
              <li>...and many other options.</li>
            </StyledBulletList>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h3" sx={{ display: 'flex', alignItems: 'center' }}>
              <img src={listSmallCalendarImage} style={{ height: '48px', marginRight: '16px' }} />
              Availability
            </Typography>
            <StyledBulletList>
              <li>Control what dates can/cannot be reserved.</li>
              <li>Set mininimum night stay requirements.</li>
              <li>Block off personal or maintenance dates.</li>
              <li>Synchronize multiple hosting calendars.</li>
            </StyledBulletList>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h3" sx={{ display: 'flex', alignItems: 'center' }}>
              <img src={listSmallRatesPricingImage} style={{ height: '48px', marginRight: '16px' }} /> Rates &amp;
              Pricing
            </Typography>
            <StyledBulletList>
              <li>Set exact nightly rates for any day or range.</li>
              <li>Promote length-of-stay discounts.</li>
              <li>Automatically adjust rates for weekends.</li>
              <li>Pricing insights available for most resorts.</li>
            </StyledBulletList>
          </Grid>
        </Grid>
      </ContentSection>

      <ContentSection>
        <DividerTemp />
      </ContentSection>
    </>
  );
};
